import { createContext, useContext, useEffect, useState } from "react";

const CartCtx = createContext(null);
export const useCart = () => useContext(CartCtx);

const KEY = "kys_cart";

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch { return []; }
  });

  useEffect(() => {
    localStorage.setItem(KEY, JSON.stringify(items));
  }, [items]);

  const lineKey = (p) => `${p.product_id}__${p.size || ""}`;

  const add = (product, size, qty = 1) => {
    setItems((prev) => {
      const key = `${product.id}__${size || ""}`;
      const existing = prev.find((i) => lineKey(i) === key);
      if (existing) {
        return prev.map((i) => (lineKey(i) === key ? { ...i, quantity: i.quantity + qty } : i));
      }
      return [
        ...prev,
        {
          product_id: product.id,
          name: product.name,
          slug: product.slug,
          price: product.price,
          size: size || null,
          quantity: qty,
          image: product.images?.[0] || null,
        },
      ];
    });
  };

  const update = (product_id, size, quantity) =>
    setItems((prev) =>
      prev.map((i) => (i.product_id === product_id && (i.size || "") === (size || "") ? { ...i, quantity } : i))
    );

  const remove = (product_id, size) =>
    setItems((prev) => prev.filter((i) => !(i.product_id === product_id && (i.size || "") === (size || ""))));

  // Put a removed line back at its original position (Undo).
  const restore = (item, index) =>
    setItems((prev) => {
      if (prev.some((i) => lineKey(i) === lineKey(item))) return prev;
      const next = [...prev];
      next.splice(Math.min(index, next.length), 0, item);
      return next;
    });

  const clear = () => setItems([]);

  const count = items.reduce((a, i) => a + i.quantity, 0);
  const subtotal = items.reduce((a, i) => a + (i.price || 0) * i.quantity, 0);

  return (
    <CartCtx.Provider value={{ items, add, update, remove, restore, clear, count, subtotal }}>
      {children}
    </CartCtx.Provider>
  );
}
